<div
  class="search-wrapper"
  [ngClass]="{
    'clickable-wrapper': context === 'main',
    'modal-wrapper': context === 'modal'
  }"
  (click)="context === 'main' && clickSearch.emit()"
>
  <label class="search-label">{{ label | translate }}</label>

  @if (context === 'modal') {
  <div class="relative">
    <ion-item lines="none" class="custom-search-item">
      <ion-icon
        name="search-outline"
        slot="start"
        class="text-gray-500 text-base"
      />
      <ion-input
        class="custom-search"
        [placeholder]="placeholder | translate"
        [(ngModel)]="search"
        (ionInput)="searchChange.emit(search)"
        type="text"
      />
    </ion-item>
    @if ((search || '').trim().length > 0) {
    <ion-icon
      name="close-circle"
      class="clear-icon"
      (click)="clearSearch(); $event.stopPropagation()"
    />
    }
  </div>
  } @else {
  <div class="relative">
    <ion-item lines="none" class="custom-search-item">
      <ion-icon
        name="search-outline"
        slot="start"
        class="text-gray-500 text-base"
      />
      <div class="fake-input-placeholder">
        {{ placeholder | translate }}
      </div>
    </ion-item>
  </div>
  }
</div>
